import React, { Component } from 'react';
import _ from "underscore";
import { Col, NavLink, Form, FormGroup, Input, Button, Nav, NavItem } from 'reactstrap';
import { connect } from 'react-redux';
import { callCardMetaDataAPI, callSetPayment, RedirectRazorPaySubmit } from 'actions/payment';
import { findObj } from 'lib/fp-utility'
import { DisplayPayBtnText, RenderForm, GoBack,DisplayConvFee, FPImages } from 'components/Common';
import GlobalLoaderModal from "components/FDModal/global-loader";

class NetBanking extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Banklist: [],
			selectbank: '',
			nbRespURL: null,
			selectedBank: '',
			rmsWebUrl:null,
			rmsRequestData:null
        }
		this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handlePay = this.handlePay.bind(this);
		this.filteredBank = this.filteredBank.bind(this);
		this.formFields = this.formFields.bind(this);
	}

	componentDidMount(){
		if(this.props.integrationType==='MERCHANT_PAYMENT_MODE_BANKORWALLET_INTEGRATION' && this.props.bankList){
			this.setState({ selectedBank: this.props.bankList[0] });
			this.callMetaData(this.props.bankList[0]);	
		}
			
	}

	callMetaData = async (slectedBankInfo) => {
		await this.setState({ selectedBank: slectedBankInfo, loader: true});	
		await callCardMetaDataAPI('NB', slectedBankInfo)
		.then((resp)=>{
			if(resp.data.response.errorCode===undefined){
				this.setState({cardMetaData: resp.data.response})
			}
		})
		this.handlePay()
	}

	async handleClick(e){
		await this.setState({ selectedBank: findObj(this.props.bankList, e, 'firstPayBankCode') });
		callCardMetaDataAPI('NB', this.state.selectedBank)
		.then((resp)=>{
			if(resp.data.response.errorCode===undefined){
				this.setState({cardMetaData: resp.data.response})
			}
		})
	}

	handleChange = (e) => {
		if(!e.target.value){
			this.setState({ selectedBank: ''});
			return true 
		}
		const bankObj = findObj(this.props.bankList, e.target.value, 'firstPayBankCode')
		this.setState({ selectedBank: bankObj });
		callCardMetaDataAPI('NB', bankObj)
		.then((resp)=>{
			if(resp.data.response.errorCode===undefined){
				this.setState({cardMetaData: resp.data.response})
			}
		})
	}
	
	handlePay = () => {
		this.setState({loader: true})
		//this.props.callSetPayment('NB', selectbank,this.props.txnKey, this.props.txnIv);
		this.props.callSetPayment('NB', this.state.selectedBank, this.props.txnKey, this.props.txnIv).then((resp) =>{
            if(resp.payload.data.paymentMethod === "NETBANKING_TPSL"){
				this.setState({nbRespURL: decodeURIComponent(resp.payload.data.netBankingUrl) })
				document.NB_TPSLForm.submit()
			}else if(resp.payload.data.paymentMethod === "NETBANKING_RAZOR"){
				this.setState({nbRespURL: resp.payload.data.merchantUrl})
				RedirectRazorPaySubmit(resp.payload.data.razorPayOrderResponseBean).then((getRazorPayResponse)=>{
					this.setState({razorPayRespData: getRazorPayResponse})
				})
			}else if(resp.payload.data.paymentMethod === "GRABPAY"){
				window.location = resp.payload.data.grabPayWebUrl;
			}
			else if(resp.payload.data.paymentMethod === "RMS"){
				this.handleRMS(resp);
			}else if(resp.payload.data.paymentMethod === "CCAVENUE"){
				window.location = resp.payload.data.redirectUrl;
			}
			else{
				this.setState({loader: false})
			}
        });
	}
	
	handleRMS = async(resp) => {
		
		const { errorCode, errorMessage, rmsRequestData,rmsWebUrl } = resp.payload.data;
		if (rmsWebUrl && rmsRequestData && rmsRequestData.trim() != "") {
			const parsedData = JSON.parse(rmsRequestData);
			this.setState({rmsWebUrl,rmsRequestData:parsedData})
		}
			
		
    }

	formFields = () => {
		const {rmsWebUrl,rmsRequestData} = this.state;
		if(rmsRequestData){
			setTimeout(() => {
				document.RMSFORM.submit();
			}, 1000);
			return Object.entries(rmsRequestData).map(([key,value]) => {
				return <input id={key} name={key} key={key} value={value} type="hidden"></input>
	
			})
		}
		
	}

	filteredBank(){
		const banks = this.props.bankList
		if(this.props.integrationType==='MERCHANT_PAYMENT_MODE_BANKORWALLET_INTEGRATION'){
			return banks
		}else{
			return banks.filter(item => item.channelName === "TPSL" || item.channelName === "RAZOR" || item.channelName === 'RMS' || item.channelName === 'CCAVENUENB')
		}
	}

	render() {
		const { t } = this.props;
		const {rmsWebUrl,rmsRequestData} = this.state;
		const filteredBank =_.sortBy(this.filteredBank(),'bankName');
		const topfilteredBank =_.sortBy(this.filteredBank(),'disaplyOrderId');
		const selectedBankCode = this.state.selectedBank && this.state.selectedBank.firstPayBankCode
		return(
			<>
			<Col xs="12">
				<div className="card-details-panel d-flex justify-content-center">
					<Form>
						<div className="list-internet-bank">
							<Nav>
								{this.props.bankList && topfilteredBank.slice(0, 6).map((el, i) => {
									return <NavItem 
									key={i} 
									onClick={(e)=> {this.handleClick(el.firstPayBankCode)}}
									className={selectedBankCode === el.firstPayBankCode ? 'active' : 'targetvalue'}
									>
										<NavLink style={{width:"100%",height:"100%"}} href="#">
											<FPImages src={el.imageLoc} />
										</NavLink>
									</NavItem>})
								}
							</Nav>
						</div>   

						<FormGroup className="custom-dd">
							<Input type="select" name="select" value={selectedBankCode} onChange={(e) => this.handleChange(e)}>
								<option value=''>-- Select Bank --</option>
								{ this.props.bankList && filteredBank.map((el, i) => <option key={i} value={el.firstPayBankCode}>{el.bankName}</option>)}
							</Input>
						</FormGroup>

						<p className="text-14 text-center mb-4">({t('click_on_pay_note')})</p>
                        {/* {
                            this.state.cardMetaData && this.state.cardMetaData.convFee && this.state.cardMetaData.convFee.fees && (
                                <div className="price-panel">
                                    <Nav>
                                        <NavItem className="text-16">Total <span className="float-right"><label>{this.state.cardMetaData.convFee.currencyCode}</label> {this.state.cardMetaData.convFee.totalAmount}</span></NavItem>
                                        {
                                            this.state.cardMetaData.convFee.fees.map((fee, i) => {
                                                return <NavItem key={i} className="text-16">{fee.title} <span className="float-right"><label>{this.state.cardMetaData.convFee.currencyCode}</label>{fee.amount}</span></NavItem>
                                            })
                                        }
                                    </Nav>
                                </div>    )
                        } */}
						<DisplayConvFee cardMetaData={this.state.cardMetaData} t={t}/>
						<Button disabled={!this.state.selectedBank || this.state.loader || !this.props.termsStatus} className="btn" onClick={this.handlePay}>
							<DisplayPayBtnText cardMetaData={this.state.cardMetaData} transactionDetails={this.props.transactionDetails} t={t} />
						</Button>

						<div className="go-back-site text-center">
							<GoBack t={t} />
						</div>
					</Form>
					{rmsRequestData && 
					
					<FormGroup>
					<form action={rmsWebUrl} name='RMSFORM' method="POST">
					   {
						   this.formFields()
					   }
					</form>
				  </FormGroup>

					}

				</div>
			</Col>
			{ this.state.loader &&  <GlobalLoaderModal transaction={true} /> }
			<RenderForm className='hidden' nbRespURL={this.state.nbRespURL} formName="NB" razorPayRespData={this.state.razorPayRespData} />
			</>
		);
	}
}

const mapStateToProps = state => {
	const { transactionDetails,termsStatus, txnKey, txnIv, globalConfig: { mConfig: { lstMerchBank: bankList, integrationType } } } = state.fdData;
	return {termsStatus, txnKey, txnIv, transactionDetails, integrationType, bankList: bankList ? bankList : [] }
}

export default connect(mapStateToProps, { callSetPayment })(NetBanking);